import React, {  LegacyRef, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";


const UserTable: React.FC<propTypes> = (props: propTypes) => {
  const containerStyle = useMemo(() => ({ width: '100%', height: '31rem', padding: '0px' }), []);
  const gridStyle = useMemo(() => ({ height: '100%', width: '100%' }), []);
  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 150,
      filter: true,
      sortable: true,
    };
  }, []);

  return (
    <div className="row">
      <div className='user-table' data-testid="user-table" style={containerStyle}>
        <div style={gridStyle} className="ag-theme-alpine">
          <AgGridReact
            ref={props.gridRef}
            rowData={props.rowData}
            columnDefs={props.columnDefs}
            defaultColDef={defaultColDef}
            onGridReady={props.onGridReady}
            rowSelection={'single'}
            suppressMenuHide={true}
            pagination={true}
            paginationAutoPageSize={true}
            onFilterChanged={() => props.filterChangedFn()}
          />
        </div>
      </div>
    </div>
  );
};

type propTypes = {
  gridRef: LegacyRef<AgGridReact<unknown>>,
  rowData: unknown[],
  columnDefs: unknown[]
  onGridReady: () => void,
  filterChangedFn: () => void
}
export default UserTable;